import tippy from 'tippy.js';

/**
 * v-tippy="'Tooltip text'"             — default placement (top)
 * v-tippy:bottom="'Tooltip text'"      — placement via directive arg
 * v-tippy.html="markupString"          — allow HTML in the content
 *
 * Theme matches the rest of the admin: 'light sincos' (defined in
 * resources/css/sincos-tippy-theme.css and imported in app.js).
 */

const DEFAULTS = {
    theme: 'light sincos',
    placement: 'top'
};

function buildOptions(binding) {
    return {
        ...DEFAULTS,
        placement: binding.arg || DEFAULTS.placement,
        content: binding.value ?? '',
        allowHTML: !!binding.modifiers.html
    };
}

export default {
    mounted(el, binding) {
        if (binding.value === null || binding.value === undefined || binding.value === '') return;
        tippy(el, buildOptions(binding));
    },
    updated(el, binding) {
        if (el._tippy) {
            // Update content/placement on reactive changes; destroy if cleared.
            if (binding.value === null || binding.value === undefined || binding.value === '') {
                el._tippy.destroy();
                return;
            }
            el._tippy.setProps(buildOptions(binding));
        } else if (binding.value) {
            tippy(el, buildOptions(binding));
        }
    },
    unmounted(el) {
        el._tippy?.destroy();
    }
};
